import React from "react";
import Accordion from "react-bootstrap/Accordion";
import AccordionButton, { useAccordionButton } from "react-bootstrap/AccordionButton";

const LegacyAccordionToggle = React.forwardRef(
    ({ as: Component = AccordionButton, eventKey, onClick, children, ...props }, ref) => {
        const handleClick = useAccordionButton(eventKey, onClick);
        const RenderComponent = Component || AccordionButton;

        return (
            <RenderComponent
                {...props}
                ref={ref}
                onClick={(event) => {
                    if (typeof handleClick === "function") {
                        handleClick(event);
                    }
                }}
            >
                {children}
            </RenderComponent>
        );
    }
);

LegacyAccordionToggle.displayName = "LegacyAccordionToggle";

// Mutate the Accordion export to expose the legacy Toggle API expected by existing widgets.
Accordion.Toggle = LegacyAccordionToggle;

export default Accordion;
